// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"888":"0207900a3f1ac012","968":"7b7f8304c180f98c"}[chunkId] + ".css";
};